import React from "react";
import "./Hero.css";
import profile from "./assets/profile.jpg";
import Navbar from "../navbar/Navbar";

function Hero() {
  return (
    <div className="hero-section">
      <Navbar />
      <div className="hero-content">
        <div className="hero-text">
          <h1>
            <span className="small">Hey there,</span>
            <span className="large">I’m</span>{" "}
            <span className="highlight">Shivansh Shrivas</span>
          </h1>
          <p>
            I’m a Computer Engineer currently studying at the University of
            Kansas, actively looking for opportunities to sharpen my software
            and hardware skills.
          </p>
        </div>
        <div className="hero-image">
          <img src={profile} alt="Shivansh Shrivas" />
        </div>
      </div>
    </div>
  );
}

export default Hero;
